/**
 * Neo4j Database Connection Configuration
 */

/**
 * Get database name from URL parameters or use default
 * Usage: ?database=mydb or ?db=mydb
 */
const getDatabaseFromUrl = (): string => {
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('database') || urlParams.get('db') || 'neo4j';
  }
  return 'neo4j';
};

export const NEO4J_CONFIG = {
  protocol: 'neo4j+s',
  hostname: 'neo4j.visuiz.com',
  port: 17778,
  get database() {
    return getDatabaseFromUrl();
  },
  // allowedDatabases: ['movies', 'hetionet', 'healthcare'], // allowed databases , put ['*'] to allow all databases
  allowedDatabases: ['*'],

  // blockedDatabases: databases to hide from the sidebar. Add database names here to exclude them.
  // Example: blockedDatabases: ['system', 'neo4j'],
  blockedDatabases: ['fraud', 'plantgenie', 'neo4j', 'system'] as string[],
};

export const DEMO_CREDENTIALS = {
  username: 'neo4juser',
  password: 'Iru@90361',
};